
import { Component, Vue } from 'vue-property-decorator'
import MallStoreService from '@/biz/service/Mall/MallStoreService'

@Component
export default class MallStoreIndex extends Vue {
  private MallStoreService = MallStoreService
}
